var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-image-background',{class:_vm.imageClass,attrs:{"file-id":_vm.fileId,"id":_vm.imageId,"background-style":_vm.imageStyle}})
}
var staticRenderFns = []

export { render, staticRenderFns }